import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ProjectUnit} from '@catmodules/models/project-units/types';
import {EntitySchemaService} from 'app/modules/core/services/entity-schema.service';
import {ProjectService} from 'app/modules/core/services/index';
import {Project} from 'app/modules/core/types/api-v2/index';
import {GenericResourceService} from 'app/modules/features/services/generic-resource.service';
import {GuiZonesService} from 'app/modules/project-details/services/gui-zones.service';
import {GuiZoneExplorerAction} from 'app/modules/project-details/types';
import {ExplorerItem, TreeNodeInfo} from 'app/modules/ui-base/types';
import {BreadcrumbService} from 'app/modules/widgets/breadcrumb/services/breadcrumb.service';
import {ExplorerCustomTree} from 'app/shared/explorer-custom-tree';
import {isNullOrUndefined} from 'util';

/**
 * This component provides the data and methods to display a customized Explorer component
 * which displays a list of all the available ProjectUnit items of a Project
 *
 */
@Component({
  templateUrl: './project-units.component.html',
  styleUrls: ['./project-units.component.scss'],
})
export class ProjectUnitsComponent extends ExplorerCustomTree implements OnInit, OnDestroy {

  constructor(route: ActivatedRoute,
              resourceService: GenericResourceService,
              schemaService: EntitySchemaService,
              breadcrumbService: BreadcrumbService,
              private projectService: ProjectService,
              private guiZonesService: GuiZonesService,
              router: Router) {
    super(route, resourceService, schemaService, breadcrumbService, router);
    this.doAllowCreate = true;
    this.setTreeResolveDepth(1);
  }

  ngOnInit() {
    this.projectService
      .getCurrentProject()
      .filter((project: Project) => {
        const isValidProject = !isNullOrUndefined(project) && !isNullOrUndefined(project.id);
        return isValidProject;
      })
      .subscribe((project: Project) => {
        const values = this.projectService.extractUnitsFrom(project);
        this.updateExplorerItems(values);
        this.initNavigationalState();

      });
    // this.guiZonesService.setActive();
  }

  // protected canBeExpanded(nodeInfo: TreeNodeInfo, defaultRouteForward = false){
  //   const excludedResourceRefs = ['parameters'];
  //   let isExcludedResource = !isNullOrUndefined(nodeInfo) && !isNullOrUndefined(nodeInfo.item);
  //   isExcludedResource = isExcludedResource && excludedResourceRefs.includes(nodeInfo.item.value.navItem.ref);
  //
  //   return !isExcludedResource;
  // }

  ngOnDestroy() {
    // this.guiZonesService.setInactive();
  }

  onActivateItem(nodeInfo: TreeNodeInfo) {
    this.router.navigate([nodeInfo.item.value], {relativeTo: this.route});
  }

  onAddOrCreate() {
    this.router.navigate(['new'], {relativeTo: this.route});
  }

  /**
   *
   * @param $event
   * @param {TreeNodeInfo} nodeInfo
   */
  navigateTo($event, nodeInfo: TreeNodeInfo) {
    $event.stopPropagation();
    this.navigateToTargetRoute(nodeInfo, true);

  }

  /**
   * Returns true if all current conditions, based on the provided TreeNodeInfo, are fullfiled successfuly
   * @param {TreeNodeInfo} item
   * @returns {boolean}
   */
  doDisplayNodeControls(item: TreeNodeInfo): boolean {
    const doAllow = this.doAllowNewItem(item) || this.doAllowDisplayLanding(item);
    return doAllow;
  }

  doAllowNewItem(node: TreeNodeInfo): boolean {
    return node.item.allowedActions.includes(GuiZoneExplorerAction.create);
  }

  doAllowDisplayLanding(node: TreeNodeInfo): boolean {
    return node.item.allowedActions.includes(GuiZoneExplorerAction.info);
  }

  getAllowCreateAction() {
    return GuiZoneExplorerAction.create;
  }

  getAllowInfoAction() {
    return GuiZoneExplorerAction.info;
  }

  private updateExplorerItems(values: ProjectUnit[]) {

    this.explorerItems = [];
    const explorerItems: ExplorerItem[] = [];
    const defaultOptions = {label: () => null, ...this.defaultFactoryOptions};
    const treeNodes = this
      .treeNodeFactory
      .getForRoot(values, {label: () => null, ...this.defaultFactoryOptions})
      .map((explorerItem: ExplorerItem) => {
        explorerItem.allowedActions = [this.getAllowCreateAction(), this.getAllowInfoAction()];
        return explorerItem;
      })
    ;
    this.explorerItems = treeNodes;
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/project-details/components/project-units/project-units.component.ts